(function () {
    'use strict';

    angular.module('swif.openbase')

        .component('swifIdLabel', {
            templateUrl: 'partials/openbase/swif_id_label.html',
            controller: SwifIdLabelController,
            bindings: {
                model: '<'
            }
        })
        .component('swifCheck', {
            template:'<i class="fa" ng-class="{\'fa-check text-success\': $ctrl.model, \'fa-times text-danger\': !$ctrl.model}"></i>',
            bindings: {
                model: '<'
            }
        })
        .component('swifCost', {
            controller: SwifCostController,
            template:'<span>{{$ctrl.cost}}</span>',
            bindings: {
                amount: '<',
                precision: '<'
            }
        })
        .component('swifCurrency',  {
            controller: SwifCurrencyController,
            template:'<span>{{$ctrl.currency}}</span>'
        })
        .component('swifSelectMultipleInTree', {
            templateUrl: 'partials/openbase/swif_select_multiple_in_tree.html',
            controller: SwifSelectMultipleInTreeController,
            bindings: {
                ngModel: '=',
                type: '@',
                label: '@',
                helpText: '@'
            }
        })
        .component('swifWidgetSelectWithBreadcrumb', {
            templateUrl: 'partials/openbase/swif_widget_select_with_breadcrumb.html',
            controller: SwifWidgetSelectWithBreadcrumbController,
            bindings: {
                model: '=',
                required: '@',
                helpText: '@'
            },
            transclude: true
        }).component('swifWidgetWarehouseBreadcrumbSelector', {
            templateUrl: 'partials/achats/swif_widget_warehouse_breadcrumb_selector.html',
            controller: SwifWidgetWarehouseBreadcrumbSelectorController,
            bindings: {
                model: '=',
                required: '@',
                helpText: '@',
                noDisplayInput: '@',
                whereLabel: '@'
            },
            transclude: true
        });
        
        function SwifWidgetSelectWithBreadcrumbController() {
            var $ctrl = this;
        }

        function SwifWidgetWarehouseBreadcrumbSelectorController() {
            var $ctrl = this;
        }
        
        function SwifSelectMultipleInTreeController($scope, dataService) {
            var $ctrl = this;

            $ctrl.childs = [];

            function fetchChildsByIds(ids, childIndex) {
                var params = {fields: ["id", "name"]};
                dataService.addFilter(params, 'service_id', 'in', ids);
                dataService.searchRead($ctrl.type, params)
                    .then(function (data) {
                        if (data.length >= 1) {
                            let firstChild = {model: {}, choices: data.records};
                            $ctrl.childs[childIndex] = firstChild;
                        }else if (data.length === 0 && $ctrl.childs[childIndex]) {
                            if ($ctrl.childs[childIndex].choices.length!=0){
                                if (childIndex>0){
                                    //we need to replace choices with no choices
                                    let firstChild = {model: {}, choices: data.records};
                                    $ctrl.childs[childIndex] = firstChild;
                                }else if (childIndex===0){
                                    $ctrl.childs = [];
                                }
                            }
                        }
                        if (childIndex<$ctrl.childs.length){
                            //we just have update a child with no model, next childs must be remove
                            $ctrl.childs.splice(childIndex+1, $ctrl.childs.length-childIndex);
                        }
                    });
            }

            $scope.$watch('$ctrl.firstChildModel', function(newV, oldV) {
                if (!_.isEmpty(newV)) {
                    $ctrl.ngModel = newV;
                    fetchChildsByIds(newV, 0);
                } else if (!_.isEmpty(oldV) && _.isUndefined(newV)){
                    //user have delete the last item in the swif-select-multiple-in-tree
                    $ctrl.ngModel = [];
                    $ctrl.childs = [];
                }
            });

            $scope.$watch('$ctrl.childs', function(newValues, oldValues) {
                if (!_.isEmpty(newValues)) {
                    if (newValues && oldValues) {
                        if (newValues.length > 0 && oldValues.length >= 0) {
                            if (newValues.length === oldValues.length) {
                                //user has change a child
                                let undefinedIndex = _.findIndex(newValues, { 'model': undefined });
                                if (undefinedIndex>=0 && undefinedIndex < $ctrl.childs.length){
                                    //user has remove the last item in a child
                                    if (undefinedIndex<$ctrl.childs.length){
                                        //if the deleted child is the last one, we don't need to remove other childs
                                        $ctrl.childs.splice(undefinedIndex+1, $ctrl.childs.length-undefinedIndex);
                                    }
                                    //we set the firstChildModel
                                    let newModelIndex = undefinedIndex-1;
                                    if (newModelIndex===-1){
                                        $ctrl.ngModel = $ctrl.firstChildModel;
                                    }else{
                                        $ctrl.ngModel = $ctrl.childs[newModelIndex].model;
                                    }
                                }else{
                                    if (! angular.equals(_.last(newValues).model, _.last(oldValues).model)){
                                        //last child model has been updated
                                        let ids = _.last(newValues).model;
                                        if (!_.isEmpty(ids)){
                                            $ctrl.ngModel = ids;
                                            fetchChildsByIds(ids, $ctrl.childs.length);
                                        }
                                    }else{
                                        // a child's model have been updated
                                        newValues.forEach(function(child, index) {
                                            if (! angular.equals(child.model, oldValues[index].model)){
                                                let ids = child.model;
                                                $ctrl.ngModel = ids;
                                                fetchChildsByIds(ids, index+1);
                                            }
                                        });
                                    }
                                }
                            } else {
                                if (newValues.length > oldValues.length) {
                                    if (newValues.length===1 && oldValues.length===0){
                                        //swif-widget-select-multiple haded the first child
                                    }else{
                                        // user has selected a new item
                                    }
                                } else if (newValues.length < oldValues.length) {
                                    // user has remove an id
                                }
                            }
                        }
                    }
                } else if (!_.isEmpty(oldValues) && _.isUndefined(newValues)){
                    //user have delete the last id in a child model
                }
            }, true);
        }

        function SwifIdLabelController($scope) {
            var $ctrl = this;

            $ctrl.$onChanges = function () {
                if ($ctrl.model) {
                    switch($ctrl.model._type) {
                        case 'intervention_request':
                            $ctrl.labelClass = 'ask-id-label';
                            break;
                        case 'ask_contrib':
                            $ctrl.labelClass = 'contrib-id-label';
                            break;
                        case 'intervention':
                            if ($ctrl.model.ask_id && $ctrl.model.ask_id[0]) {
                                $ctrl.labelClass = 'ask-id-label';
                            } else {
                                $ctrl.labelClass = 'intervention-id-label';
                            }
                            break;
                        case 'task':
                            if ($ctrl.model.ask_id) {
                                $ctrl.labelClass = 'ask-id-label';
                            } else if ($ctrl.model.ask_id === false && $ctrl.model.project_id) {
                                $ctrl.labelClass = 'intervention-id-label';
                            } else if ($ctrl.model.project_id === false) {
                                $ctrl.labelClass = 'task-id-label';
                            }
                            break;
                        case 'openstc_ask_prod':
                            $ctrl.labelClass = 'askProd-id-label';
                            break;
                        case 'quotation':
                            $ctrl.labelClass = 'quotation-id-label';
                            break;
                        case 'purchase_order':
                            if ($ctrl.model.po_ask_id) {
                                $ctrl.labelClass = 'poFromPoAsk-id-label';
                            } else {
                                $ctrl.labelClass = 'po-id-label';
                            }
                            break;
                    }
                }
            }
        }


        function SwifCostController(swifOpenbaseCompanyService) {
            var $ctrl = this;

            $ctrl.$onChanges = function (changes) {
                if (changes.amount) {
                    if(!this.precision){
                        this.precision = 2;
                    }
                    // Round using exponential notation for better precision
                    var rounded = Number(Math.round(changes.amount.currentValue + 'e'+this.precision) + 'e-'+this.precision).toFixed(this.precision);

                    swifOpenbaseCompanyService.formatCurrency(rounded).then(
                        function(cost){
                            $ctrl.cost = cost;
                        }
                    );
                }
            };
        }

        function SwifCurrencyController(swifOpenbaseCompanyService) {
            var $ctrl = this;

            $ctrl.$onInit = function () {
                swifOpenbaseCompanyService.getCurrencySymbol().then(function(symbol){
                    $ctrl.currency = symbol;
                });
            };
        }

})();
